import { Controller } from '@hotwired/stimulus'

// TODO(sca): refactor similar controller
export default class IframeScaController extends Controller {
  static targets = [];

  static values = {
    profileId: String,
  };

  connect() {
    this.subscribeToChannel();
  }

  subscribeToChannel() {
    App.cable.subscriptions.create(
      {
        channel: 'IframeScaChannel',
        profile_id: this.profileIdValue,
      },
      {
        received(data) {
          this.unsubscribe();

          if (data.flash_message) {
            if (data.flash_message.type == 'error') {
              toastr.error(data.flash_message.message);
            }

            setTimeout(() => {
              window.location.href = data.redirect_url;
            }, 3000);
          } else {
            window.location.href = data.redirect_url;
          }
        },
      }
    );
  }
}
